export default "__VITE_ASSET__47862535__"